/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import { CircularProgress } from "@mui/material";
import API from "../../Utils/Interceptor/ApiMiddleware";
import CustomSnackbar from "../../components/Composables/CustomSnackBarMenu";

const BlogDisplay = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState([]);
  const [loading, setLoading] = useState(true);
  const [backbutton, setbackbutton] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [openDialog, setOpenDialog] = useState(false); // State to open/close dialog
  // Handle opening the dialog
  const handleDeleteClick = () => {
    setOpenDialog(true); // Open confirmation dialog
  };

  // Handle closing the dialog without doing anything
  const handleCloseDialog = () => {
    setOpenDialog(false); // Close dialog
  };

  // Handle confirming the deletion
  const handleConfirmDelete = async () => {
    try {
      const response = await API.delete(`/delete-blog/${id}`);
      if (response?.data?.success) {
        setSnackbar({
          open: true,
          message: response?.data?.data,
          severity: "success",
        });
      }
      setTimeout(() => {
        navigate("/blogs");
      }, 2000);
    } catch (error) {
      console.error("Error deleting blog:", error);
      setSnackbar({
        open: true,
        message: "Failed to delete blog",
        severity: "error",
      });
      // Optionally, show an error message
    } finally {
      setOpenDialog(false); // Close dialog after action
    }
  };
  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  const getBlog = async () => {
    setLoading(true);
    try {
      const response = await API.get(`/blog/${id}`);
      setBlog(response.data.data[0]);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getBlog();
  }, []);
  const sanitizeAndStyleHTML = (htmlContent, altTags) => {
    if (!blog && blog.length === 0) {
      return;
    }
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;

    // Split the altTags string by commas into an array
    const altTagsArray = altTags?.split(",").slice(1);

    // Get all img elements in the tempDiv
    const images = tempDiv.getElementsByTagName("img");

    // Loop through each img element and set styles and alt attribute
    for (let i = 0; i < images.length; i++) {
      const img = images[i];

      // Set styling
      img.style.maxWidth = "100%";
      img.style.height = "auto";
      img.style.objectFit = "cover";
      img.style.borderRadius = "12px";

      // Set alt attribute from the altTags array if available
      if (altTagsArray[i]) {
        img.alt = altTagsArray[i].trim(); // Trim to remove any extra whitespace
      } else {
        img.alt = "Jobeze - AI-powered job assistant"; // Default alt text if no altTag is provided
      }
    }

    return tempDiv.innerHTML;
  };
  const styledContent = sanitizeAndStyleHTML(blog.content, blog.alt_text);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      className="pageWrapper"
      sx={{
        background: "#E3F2FD",
        padding: "16px 16px",
        height: "100%",
        overflow: "auto",
        borderRadius: "24px 0 0 0",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "white",
          padding: "16px",
          borderRadius: "12px",
          marginBottom: "16px",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <Button
            startIcon={
              <ChevronLeftOutlinedIcon
                style={{ height: "16px", width: "16px" }}
              />
            }
            sx={{
              "& .MuiButton-startIcon": backbutton
                ? { marginRight: "4px !important" }
                : { margin: "0px" },
            }}
            style={
              backbutton
                ? {
                    backgroundColor: "#3F95EA",
                    color: "white",
                    height: "24px",
                    fontSize: "12px",
                    textTransform: "none",
                  }
                : {
                    backgroundColor: "#E7E7E7",
                    color: "#1A1A1A",
                    minWidth: "24px",
                    height: "24px",
                    padding: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }
            }
            onMouseEnter={() => setbackbutton(true)}
            onMouseLeave={() => setbackbutton(false)}
            onClick={() => navigate(-1)}
          >
            {backbutton ? "Back" : ""}
          </Button>
          <Typography variant="h6" sx={{ fontWeight: "600" }}>
            Blog Details
          </Typography>
        </Box>

        <Box>
          <Button
            size="small"
            variant="contained"
            onClick={() => navigate(`/blogs/${id}/edit`)}
            sx={{ mr: 1.5 }}
          >
            Edit
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="error"
            onClick={handleDeleteClick}
          >
            Delete
          </Button>
        </Box>
      </Box>

      <Card
        sx={{
          boxShadow: "none",
          padding: "16px",
          borderRadius: "12px",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            pr: 1,
          }}
        >
          <Typography
            variant="h3"
            gutterBottom
            sx={{
              fontSize: { xs: "24px", md: "28px", lg: "28px" },
              fontWeight: "700",
            }}
          >
            {blog.title}
          </Typography>

          <CardMedia
            component="img"
            image={blog.featured_image}
            alt={blog?.alt_text?.split(",", 1)}
            sx={{
              borderRadius: "12px",
              height: "auto",
              objectFit: "cover",
              marginBottom: "12px",
            }}
          />

          <CardContent sx={{ padding: "0px !important" }}>
            <Typography
              variant="body1"
              paragraph
              sx={{
                marginTop: "8px",
                fontWeight: "400",
                lineHeight: { xs: "28px", sm: "32px" },
                textAlign: "justify",
              }}
            >
              {blog.description}
            </Typography>
            <div
              style={{ textAlign: "-moz-initial" }}
              dangerouslySetInnerHTML={{ __html: styledContent }}
            />
          </CardContent>
        </Box>
      </Card>

      {/* Confirmation Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this blog?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            No
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};

export default BlogDisplay;
